
(() => {
  const init = (root) => {
    if (root.dataset.posyReady) return;
    const wrappers = [0].map(i => document.querySelector('.selector-wrapper.index-' + i + ' .wetheme-dropdown'));
    if (wrappers.some(x => !x)) return;
    const groups = [0].map(i => root.querySelector('[data-option-index="' + i + '"]'));
    for (let i = 0; i < 1; i++) {
      const values = Array.from(wrappers[i].querySelectorAll('ul li[value]')).map(x => x.getAttribute('value'));
      if (Array.from(groups[i].querySelectorAll('button[data-value]')).some(x => !values.includes(x.dataset.value))) return;
    }
    const sync = () => {
      for (let i = 0; i < 1; i++) {
        const selected = wrappers[i].closest('.selector-wrapper').querySelector('select')?.value;
        groups[i].querySelectorAll('button[data-value]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.value === selected)));
      }
    };
    root.addEventListener('click', event => {
      const card = event.target.closest('button[data-value]');
      if (!card || !root.contains(card)) return;
      const i = Number(card.closest('[data-option-index]').dataset.optionIndex);
      const li = Array.from(wrappers[i].querySelectorAll('ul li[value]')).find(x => x.getAttribute('value') === card.dataset.value);
      if (!li) return;
      li.click();
      requestAnimationFrame(sync);
      setTimeout(sync, 120);
    });
    wrappers.forEach(x => new MutationObserver(sync).observe(x, {subtree:true,attributes:true,childList:true,characterData:true}));
    sync();
    root.dataset.posyReady = 'true';
    if (!new URLSearchParams(window.location.search).has('variant')) {
      const tabbed = root.querySelector('[data-option-index="1"] button[data-value="ADD monthly tabs"]');
      if (tabbed && tabbed.getAttribute('aria-pressed') !== 'true') tabbed.click();
    }
    wrappers.forEach(x => x.closest('.selector-wrapper').classList.add('posy-weekly-choices__source-hidden'));
  };
  const boot = () => document.querySelectorAll('[data-posy-weekly-choices]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true}); else boot();
  const readyObserver = new MutationObserver(() => {
    boot();
    if (document.querySelector('[data-posy-weekly-choices][data-posy-ready]')) readyObserver.disconnect();
  });
  readyObserver.observe(document.body, {childList:true, subtree:true});
  setTimeout(() => readyObserver.disconnect(), 10000);
})();
